export default __webpack_public_path__ + "assets/miltoncommon.e64ff6d7.jpg";